import * as React from 'react';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import styled from '@emotion/styled';
import device from '../../../../style/devices';
import { SearchItem } from '../../../../interfaces/interfaces';
import SearchInput from '../SearchInput';

interface SearchProps {
  nameOfSearch: string;

  onSearch(x: SearchItem): void;
}

const StyledForm = styled.form`
  margin-bottom: 1rem;
`;

const StyledAutocompleteInput = styled.div`
  flex: 1;
  margin: 0 5px;

  @media (${device.mobile}) {
    margin: 5px 5px;
    flex: auto;
  }
`;

const StyledContainersForm = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  @media (${device.mobile}) {
    flex-direction: column;
    align-content: space-between;
  }
`;

const StyledButtonContainer = styled.div`
  margin: 0 10px 0 5px;
  display: flex;
  align-items: flex-end;
`;

const SearchApp = ({ onSearch, nameOfSearch }: SearchProps) => {
  const [embedding, setEmbedding] = React.useState<string | null>(null);

  const onSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      onSearch({
        embedding,
      });
    },
    [embedding, onSearch]
  );

  React.useEffect(() => {
    onSearch({
      embedding,
    });
  }, [embedding, onSearch]);

  React.useEffect(() => {
    setEmbedding('');
  }, [nameOfSearch]);

  return (
    <StyledForm onSubmit={onSubmit}>
      <StyledContainersForm>
        <StyledAutocompleteInput>
          <SearchInput value={embedding} setValue={setEmbedding} placeholder="Search" />
        </StyledAutocompleteInput>
        <StyledButtonContainer>
          <Button variant="contained" type="submit" sx={{ width: '100%', height: '100%' }}>
            <SearchIcon sx={{ color: 'white', height: '100%' }} />
          </Button>
        </StyledButtonContainer>
      </StyledContainersForm>
    </StyledForm>
  );
};

export default SearchApp;
